import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Video from '../../base/media/components/web/Video';
import { trackVideoStarted } from '../../base/tracks/actions.any';
import { getHandoffProbeVideo } from '../mediaReadiness';
/** A bounded renderer for the existing camera, independent of self-view visibility. */
export default function HandoffVideoProbe() {
    const dispatch = useDispatch();
    const videoTrack = useSelector(getHandoffProbeVideo);
    if (!videoTrack) {
        return null;
    }
    return (React.createElement("div", { "aria-hidden": true, style: { height: 1, opacity: 0, pointerEvents: 'none', position: 'absolute', width: 1 } },
        React.createElement(Video, { autoPlay: true, className: '', id: 'handoff-video-readiness', muted: true, onVideoPlaying: () => dispatch(trackVideoStarted(videoTrack.jitsiTrack)), style: { height: 1, width: 1 }, videoTrack: videoTrack })));
}
